import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { LinkWidget } from 'pages/Vendor/Widgets/LinkWidget/LinkWidget';
import { authStoreUrlSelector } from 'state/auth/selectors';
import { MarketingWidget } from 'pages/Vendor/Widgets/MarketingWidget/MarketingWidget';
import { StepsWidget } from 'pages/Vendor/Widgets/StepsWidget/StepsWidget';
import { StepsExpanded } from 'pages/Vendor/Widgets/StepsWidget/StepsExpanded';
import { FullnessWidget } from 'pages/Vendor/Widgets/FullnessWidget/FullnessWidget';
import { StatisticWidget } from '../Widgets/StatisticWidget/StatisticWidget';

const useStyles = makeStyles(theme => ({
    header: {
        padding: theme.spacing(2),
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
    },
    half: {
        flexBasis: '47.34%',
        margin: theme.spacing(1.5),
    },
    full: {
        flexBasis: '100%',
        margin: theme.spacing(1.5),
    },
    workZone: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.spacing(0.5),
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        [theme.breakpoints.down(640)]: {
            marginBottom: theme.spacing(8),
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(3),
            marginLeft: theme.spacing(3.5),
            marginRight: theme.spacing(3.5),
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: 0,
            marginRight: 0,
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: 904,
        },
    },
}));

export const VendorDashboard = () => {
    const classes = useStyles();
    const [showExpandedSteps, setShowExpandedSteps] = useState(false);
    const storeUrl: string = useSelector(authStoreUrlSelector);
    return (
        <>
            {showExpandedSteps && <StepsExpanded onClose={() => setShowExpandedSteps(false)} />}
            <div className={classes.container}>
                <div className={classes.workZone}>
                    <div className={classes.full}>
                        <StatisticWidget />
                    </div>
                    <div className={classes.half}>
                        <LinkWidget storeLink={storeUrl} />
                    </div>
                    <div className={classes.half}>
                        <MarketingWidget />
                    </div>
                    <FullnessWidget />
                    <div className={classes.full}>
                        <StepsWidget onOpenExpanded={() => setShowExpandedSteps(true)} />
                    </div>
                </div>
            </div>
        </>
    );
};
